// extracted by mini-css-extract-plugin
export var primaryMenuList = "Navigation-module--primary-menu-list--2-RXP";
export var subMenuList = "Navigation-module--sub-menu-list--2V1is";
export var primaryMenuItem = "Navigation-module--primary-menu-item--dxzi4";
export var moreButton = "Navigation-module--more-button--2oMIt";
export var subMenuItem = "Navigation-module--sub-menu-item--nmq59";